import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import ProdutoFrame from './ProdutoFrame';

const { Item: ItemForm } = Form;

export default class PedidoItemForm extends Component {
  state = {
    editando: false,
    temGrade: false,
    listaProdutos: [],
    registro: {
      vi_seq: 0,
      vi_item: { key: '0' },
      prod_codigo: '',
      prod_descricao: '',
      vi_qtde: 1,
      vi_vlr_unit: 0,
      vi_perc_desc: 0,
      vi_vlr_desc: 0,
      vi_vlr_acres: 0,
      vi_vlr_total: 0,
      vi_perc_comissao: 0,
      vi_tabela: 0,
      vi_vlr_tabela: 0,
      vi_idf_producao: null,
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.produtoSelecionado !== propsAnterior.produtoSelecionado) {
      // console.log('componentDidUpdate: ', this.props.produtoSelecionado)
      this.setState({
        registro: this.props.produtoSelecionado.registro,
        listaProdutos: this.props.produtoSelecionado.listaProdutos ? this.props.produtoSelecionado.listaProdutos : [],
        editando: this.props.produtoSelecionado.editando,
        temGrade: this.props.produtoSelecionado.temGrade,
      }, () => {
        this.forceUpdate();
        // this.calculoItem(this.props.produtoSelecionado.registro.vi_qtde, parseFloat(this.props.produtoSelecionado.registro.prod_preco_tab1), this.props.produtoSelecionado.registro.vi_perc_desc)
      });
    }
  }

  componentDidMount() {

  }


  onOK = () => {
    const { vi_seq, vi_item, vi_qtde, vi_vlr_unit, vi_perc_desc, vi_vlr_acres, vi_vlr_desc, vi_vlr_total, vi_vlr_tabela } = this.state.registro;

    let iIndProd = -1;
    if ((!vi_item) || (vi_item.key === '0') || (vi_item.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }

    if (!vi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }

    const vlrTotalAux = parseFloat(vi_vlr_total);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
      return;
    }


    let iIndItem = -1;
    for (var x in this.state.listaProdutos) {
      if (String(this.state.listaProdutos[x].vi_item) === String(vi_item.key)) {
        iIndItem = x;
      }
    }

    // console.log('onOK: ', iIndItem);

    if (iIndItem >= 0) {

      this.state.listaProdutos[iIndItem].vi_qtde = parseFloat(vi_qtde);
      this.state.listaProdutos[iIndItem].vi_vlr_unit = parseFloat(vi_vlr_unit);
      this.state.listaProdutos[iIndItem].vi_perc_desc = parseFloat(vi_perc_desc === '' ? '0' : vi_perc_desc);
      this.state.listaProdutos[iIndItem].vi_vlr_desc = parseFloat(vi_vlr_desc === '' ? '0' : vi_vlr_desc);
      this.state.listaProdutos[iIndItem].vi_vlr_acres = parseFloat(vi_vlr_acres === '' ? '0' : vi_vlr_acres);
      this.state.listaProdutos[iIndItem].vi_vlr_total = parseFloat(vi_vlr_total);

    } else {

      this.state.listaProdutos.push({
        ven_idf: 0,
        vi_item: vi_item.key,
        vi_seq: this.state.listaProdutos.length + 1,
        prod_idf: vi_item.key,
        prod_codigo: vi_item.prod_codigo,
        prod_descricao: vi_item.prod_descricao,
        vi_qtde: parseFloat(vi_qtde),
        vi_vlr_unit: parseFloat(vi_vlr_unit),
        vi_perc_desc: parseFloat(vi_perc_desc === '' ? '0' : vi_perc_desc),
        vi_vlr_desc: parseFloat(vi_vlr_desc === '' ? '0' : vi_vlr_desc),
        vi_vlr_acres: parseFloat(vi_vlr_acres === '' ? '0' : vi_vlr_acres),
        vi_vlr_total: parseFloat(vi_vlr_total),
        vi_perc_comissao: 0,
        vi_tabela: 1,
        vi_vlr_tabela: parseFloat(vi_vlr_tabela),
        vi_idf_producao: null,
      });

    }

    this.props.onSalvarProdutoClick(this.state.listaProdutos);
  };



  onChangeProduto = event => {
    const { registro } = this.state;
    registro['vi_item'] = event.vi_item;
    registro['vi_vlr_unit'] = event.vi_item.prod_preco_tab1;
    registro['vi_vlr_tabela'] = event.vi_item.prod_preco_tab1;
    this.setState(event);
    this.calculoItem(registro.vi_qtde, parseFloat(event.vi_item.prod_preco_tab1), registro.vi_perc_desc);
  }


  onInputChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(value, registro.vi_vlr_unit, registro.vi_perc_desc);
  }

  onInputChangeVlrUnit = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(registro.vi_qtde, value, registro.vi_perc_desc);
  }

  onInputChangePercDesc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(registro.vi_qtde, registro.vi_vlr_unit, value);
  }

  calculoItem = (vi_qtde, vi_vlr_unit, vi_perc_desc) => {
    const { registro } = this.state;
    const vlrUnit = parseFloat(vi_vlr_unit);
    const qtde = parseFloat(vi_qtde);
    let percDesc = vi_perc_desc ? (parseFloat(vi_perc_desc) / 100) : 0;
    let vlrDesc = 0;
    vlrDesc = parseFloat((parseFloat(vi_qtde) * parseFloat(vlrUnit)) * percDesc);
    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    registro.vi_vlr_total = vlrTotal;
    registro.vi_vlr_desc = vlrDesc;
    this.setState({
      registro
    });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalProdutoClick, visivel } = this.props;

    const { editando, temGrade } = this.state;
    const { vi_item, vi_qtde, vi_vlr_unit, vi_perc_desc, vi_vlr_total, vi_vlr_tabela } = this.state.registro;

    // console.log('PedidoItemForm.this.state: ', this.state);

    return (
      <Modal
        title={editando ? "Editar Produto" : "Incluir Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalProdutoClick}
        footer={null}
        width={"50%"}
        style={{ top: 50 }}
      >
        <div>

          <Row>

            <Col xs={24}>
              <ProdutoFrame
                label="Produto"
                id="vi_item"
                value={vi_item}
                verifica_prod_vend={true}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Selecione um Produto"
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde</span>
              <InputForm
                type="number"
                id="vi_qtde"
                ref="vi_qtde"
                value={vi_qtde}
                onChange={this.onInputChangeQtde}
                disabled={temGrade}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Venda</span>
              <InputForm
                type="number"
                id="vi_vlr_unit"
                ref="vi_vlr_unit"
                value={vi_vlr_unit}
                onChange={this.onInputChangeVlrUnit}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Desconto (%)</span>
              <InputForm
                type="number"
                id="vi_perc_desc"
                ref="vi_perc_desc"
                value={vi_perc_desc}
                onChange={this.onInputChangePercDesc}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Valor Total</span>
              <InputForm
                type="number"
                id="vi_vlr_total"
                ref="vi_vlr_total"
                value={vi_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  className="botoesModalForm2x"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onFecharModalProdutoClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PedidoItemForm.js